
import { useKpiCardsState } from './hooks/useKpiCardsState';
import { useEditMode } from './hooks/useEditMode';
import { useCardMovement } from './hooks/useCardMovement';
import { useDragAndDrop } from './hooks/useDragAndDrop';
import { useQaTesting } from './hooks/useQaTesting';

/**
 * Main hook that combines all dashboard state hooks
 * This is used by the WaterDashboardProvider to create the context value
 */
export const useDashboardState = () => {
  // KPI cards state and management
  const { 
    kpiCards, 
    setKpiCards, 
    addKpiCard, 
    updateKpiCard, 
    removeKpiCard 
  } = useKpiCardsState();
  
  // Edit mode state and toggling
  const { isEditMode, toggleEditMode } = useEditMode();
  
  // Card movement functionality
  const { moveKpiCard } = useCardMovement(kpiCards, setKpiCards);
  
  // Drag and drop functionality
  const { 
    draggedCardId, 
    dragOverCardId, 
    dragStart, 
    dragOver, 
    drop 
  } = useDragAndDrop(kpiCards, setKpiCards);
  
  // Run QA testing to automatically position cards (for testing purposes)
  useQaTesting(kpiCards, setKpiCards);

  // Return all state and functions needed by consumers
  return {
    kpiCards,
    addKpiCard,
    updateKpiCard,
    removeKpiCard,
    moveKpiCard,
    isEditMode,
    toggleEditMode,
    dragStart,
    dragOver,
    drop,
    draggedCardId,
    dragOverCardId,
  };
};
